import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

// Components
import { Alert, ListGroup, Button } from "react-bootstrap";

// Actions
import { selectBusiness, resetBusiness } from "../actions/Menu";
import { formatName } from "../actions/Users";

export const SelectBusiness = ({
  auth: { user, groups },
  selectBusiness,
  resetBusiness,
}) => {
  const userName = user?.attributes?.given_name;

  React.useEffect(() => {
    resetBusiness();
  }, [resetBusiness]);

  return (
    <div>
      {!groups && (
        <div>
          <Alert variant="danger" className="mt-3">
            No group found on your account, please logout and try again, if
            issue persist contact our team.
          </Alert>
          <Button as={Link} variant="outline-dark mt-3" to="/logout">
            Log out
          </Button>
        </div>
      )}
      {groups && groups.length > 1 && userName && (
        <div>
          {/* display { firstName } when login in */}
          <h3 className="baskerville mt-5 mb-4">
            Hey {userName}, select a business:
          </h3>
          <ListGroup>
            {groups &&
              groups.map((item, i) => (
                <ListGroup.Item
                  key={i}
                  action
                  onClick={() => selectBusiness(item)}
                >
                  {formatName(item)}
                </ListGroup.Item>
              ))}
          </ListGroup>
          <Button as={Link} variant="outline-dark mt-3" to="/logout">
            Log out
          </Button>
        </div>
      )}
    </div>
  );
};

SelectBusiness.propTypes = {
  selectBusiness: PropTypes.func.isRequired,
  business: PropTypes.array,
  userName: PropTypes.string,
  auth: PropTypes.object.isRequired,
  resetBusiness: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {
  selectBusiness,
  resetBusiness,
})(SelectBusiness);
